import { PageTitle } from "@/components/pageTitle";
import { cn } from "@/lib/utils";

export const SolutionsRemote = () => {
  return (
    <div className="flex justify-center">
      <div className="pt-[64px] w-[1920px]">
        <Item
          id="remote-office"
          title="SD-WAN远程办公"
          imgsrc="/imgs/solutions/1.png"
        >
          <div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[30px] text-[#333333]">
              SD-WAN远程办公，纯软件部署方案
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              基于SD-WAN智能组网方案，通过组建异地虚拟局域网,实现异地局域网内电脑、手机、服务器的互联互通，为个人及企业用户提供远程办公支持。
            </div>
          </div>
        </Item>
        <Item
          id="smart-security"
          title="智慧安防解决方案"
          pageClassName="bg-gradient-to-b from-white via-[#E8F3FF] to-white"
          className="flex-row-reverse"
          imgsrc="/imgs/solutions/2.png"
        >
          <div>
            <ItemTitle title="方案部署" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              安防监控中心与各安防监控点均部署一台光年K-WAN
              CPE路由器基于”SD-WAN+物联网”智能组网网络架构，通过云平台将多地的路由器组建成一
              个大型虚拟局域网
              安防监控中心视频资源平台可集中管理所有视频监控，在内网随时查看全城视频监
              控。
            </div>
            <ItemTitle title="方案优点" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              <div className="flex items-center gap-[2px]">
                <div className="text-[#003366] min-w-[100px] block">
                  兼容性强:
                </div>
                <div>兼容不同运营商网络，联网即用</div>
              </div>
              <div className="flex items-start  gap-[2px]">
                <div className="text-[#003366] min-w-[100px]">部署灵活:</div>
                <div>不改变原有网络结构，弹性管理新增的安防监控点</div>
              </div>
              <div className="flex items-start gap-[2px]">
                <p className="inline">
                  <span className="text-[#003366] inline ">数据安全:</span>
                  通过云虚拟局域网技术提供安全隧道，保证视频资源传输安全
                </p>
              </div>
            </div>
          </div>
        </Item>
        <Item
          id="it-internet"
          title="IT互联网解决方案"
          imgsrc="/imgs/solutions/3.png"
        >
          <div>
            <ItemTitle title="方案部署" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              1、企业总部与各分支、子公司等地均部署光年K-WANCPE路由器，个人外出使用可安装光年无界客户端软件
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              2、以“打造互联网规范化管理平台”为核心目标，通过云平台将多地的路由器组建成个大型虚拟局域网
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              3、结合OA办公、ERP、NAS、FTP服务器等等，实现跨地域、跨网络、跨系统的互联互通，为IT互联网业务提供一个强大的管理支撑平台
            </div>
            <ItemTitle title="方案优点" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">兼容性强:</span>
                  建立互联互通的统一管理平台，各分支多系统共同协作
                </p>
              </div>
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">远程维护:</span>
                  随时随地远程连接，简约工作流程，降低时间成本
                </p>
              </div>
              <p className="inline">
                <span className="text-[#003366] inline ">数据安全:</span>
                企业内部信息数据传输、存储时加密处理
              </p>
            </div>
          </div>
        </Item>
        <Item
          id="smart-manufacture"
          title="智能制造解决方案"
          imgsrc="/imgs/solutions/4.png"
          pageClassName="bg-gradient-to-b from-white via-[#E8F3FF] to-white"
          className="flex-row-reverse"
        >
          <div>
            <ItemTitle title="方案部署" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              1、工厂总部与各个分厂、生产物料仓库等地均部署光年K-WAN CPE路由器
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              2、以”建立强大的生产信息链”为目标，通过云平台将多地的路由器组建成一个大型虚拟局域网
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              3、结合现有的制造信息系统，为不同区域的制造工厂搭建灵活、高效、弹性可扩展的生产管理信息化平台
            </div>
            <ItemTitle title="方案优点" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">兼容性强:</span>
                  兼容不同运营商网络，联网即用
                </p>
              </div>
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">远程维护:</span>
                  自建管理中心独立管理、弹性部署与管理新增工厂的网络
                </p>
              </div>
              <p className="inline">
                <span className="text-[#003366] inline ">数据共享:</span>
                海量设备数据实时上传，存储，处理，集中管理
              </p>
            </div>
          </div>
        </Item>
        <Item
          id="smart-traffic"
          title="智能交通解决方案"
          imgsrc="/imgs/solutions/5.png"
        >
          <div>
            <ItemTitle title="方案部署" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              1、安防监控中心与各安防监控点均部署一台光年K-WAN CPE路由器
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              2、以“实时监测+智能调度运营”为核心，通过云平台将多地的路由器组建成一个大型
              虚拟局域网
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              3、结合视频监控管理系统、车载客流统计系统、车辆调度运营管理系统等系统，打造
              监测、调度运营、车辆动态跟踪的交通信息管理体系
            </div>
            <ItemTitle title="方案优点" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">部署灵活:</span>
                  弹性管理新增的交通点，远程维护
                </p>
              </div>
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">数据安全:</span>
                  交通信息数据传输、存储时加密处理成本较低:方案实施成本低、周期短，管理维护成本低
                </p>
              </div>
            </div>
          </div>
        </Item>
        <Item
          id="smart-medical"
          title="智慧医疗解决方案"
          pageClassName="bg-gradient-to-b from-white via-[#E8F3FF] to-white"
          className="flex-row-reverse"
          imgsrc="/imgs/solutions/6.png"
        >
          <div>
            <ItemTitle title="方案部署" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              1、医院总部与各地医疗分支、体检中心、医疗固定资产中心、病房等地均部署光年K-WAN路由器
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              2、以”打造医疗大数据信息集成平台”为目标，通过云平台将多地的路由器组建成一个
              大型虚拟局域网
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              3、结合体检、诊断、治疗、辅助等多类医疗设备，实现患者与医务人员、医疗机构、
              医疗设备之间的互动，逐步达到全面信息化
            </div>
            <ItemTitle title="方案优点" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">远程连接:</span>
                  线上预约数据及时回传医院，合理分配资源远程会诊
                </p>
              </div>
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">统一管理:</span>
                  将各医疗软件系统的数据采集汇聚，建立医疗大数据平台
                </p>
              </div>
              <p className="inline">
                <span className="text-[#003366] inline ">数据安全:</span>
                医疗信息数据传输、存储时加密处理
              </p>
            </div>
          </div>
        </Item>
        <Item
          id="retail-chain"
          title="零售连锁解决方案"
          imgsrc="/imgs/solutions/7.png"
        >
          <div>
            <ItemTitle title="方案部署" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              1、零售总部与各连锁门店、商品仓库、供应商等地均部署一台光年K-WAN
              CPE路由器
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              2、以“打造智慧新零售”为目标，通过云平台将多地的路由器组建成一个大型虚拟局域网
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              3、结合收银系统、视频监控系统、进销存等系统，升级门店运营式，打通线上线下，实现信息化管理并提高门店工作效率
            </div>
            <ItemTitle title="方案优点" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">部署灵活:</span>
                  新增的连锁门店连接互联网即可加入组网
                </p>
              </div>
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">数据共享:</span>
                  商品热销指数、库存数量等信息多门店共享
                </p>
              </div>
              <p className="inline">
                <span className="text-[#003366] inline ">成本较低:</span>
                管理维护多门店，无需到现场，实施成本低
              </p>
            </div>
          </div>
        </Item>
        <Item
          id="smart-hotel"
          title="智慧酒店解决方案"
          imgsrc="/imgs/solutions/8.png"
          pageClassName="bg-gradient-to-b from-white via-[#E8F3FF] to-white"
          className="flex-row-reverse"
        >
          <div>
            <ItemTitle title="方案部署" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              1、酒店总部与各连锁酒店等地均部署光年K-WAN CPE路由器
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              2、以”打造网上销售平台与酒店信息管理中心”为目标，通过云平台将多地的路由器组
              建成一个大型虚拟局域网
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              3、结合OA办公，收银，灯光设备控制、客房外等公共区域的视频监控等系统实现酒
              店智能化、信息化
            </div>
            <ItemTitle title="方案优点" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">兼容性强:</span>
                  兼容不同运营商网络，联网即用
                </p>
              </div>
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">统一管理:</span>
                  将各连锁酒店的多类控制系统、收银系统，监控系统等信息汇总，建立酒店信息管理中心
                </p>
              </div>
              <p className="inline">
                <span className="text-[#003366] inline ">数据安全:</span>
                通过云虚拟局域网技术提供安全隧道，保证视频等信息资源传输安全
              </p>
            </div>
          </div>
        </Item>
        <Item
          id="smart-education"
          title="智慧教育解决方案"
          imgsrc="/imgs/solutions/9.png"
        >
          <div>
            <ItemTitle title="方案部署" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              1、各高校本部与各分校区、信息网络中心、多媒体教学中心等地均部署光年K-WAN
              CPE路由器
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              2、以“物联网””大数据“为技术基础，通过云平台将多地的路由器组建成一个大型虚拟
              局域网
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] ">
              3、结合教务管理、OA办公、校园安防等系统，实现人、物、校区功能系统之间无缝连接，提供信息化教务管理服务
            </div>
            <ItemTitle title="方案优点" />
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[22px] text-[#333333] mt-[20px]">
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">资源共享:</span>
                  实现教育基础数据的有序开放与共享
                </p>
              </div>
              <div>
                <p className="inline">
                  <span className="text-[#003366] inline ">远程维护:</span>
                  简约工作流程，提高工作效率
                </p>
              </div>
              <p className="inline">
                <span className="text-[#003366] inline ">统一管理:</span>
                建立互联互通的统一管理平台，多教育平台协同发展
              </p>
            </div>
          </div>
        </Item>
      </div>
    </div>
  );
};

const Item = ({
  children,
  title,
  className,
  imgsrc,
  pageClassName,
  id,
}: {
  children: React.ReactNode;
  title: string;
  className?: string;
  imgsrc?: string;
  pageClassName?: string;
  id?: string;
}) => {
  return (
    <div id={id} className={cn("mb-[100px] px-[200px]", pageClassName)}>
      <PageTitle title={title} />
      <div
        className={cn(
          "flex justify-between items-center mt-[100px] gap-[20px]",
          className
        )}
      >
        <img
          className="w-[40vw] h-[570px] min-w-[900px] mr-[38px]"
          src={imgsrc}
        />
        {children}
      </div>
      <div className="mt-[150px] px-[270px]">
        <div
          className="h-[8px]"
          style={{
            backgroundImage:
              "linear-gradient(90deg, #FFFFFF 0%, #1FB4EE 30.77%, #0076FD 68.27%, #FFFFFF 100%)",
          }}
        ></div>
      </div>
    </div>
  );
};

const ItemTitle = ({ title }: { title: string }) => {
  return (
    <div
      className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-medium text-[30px] text-left"
      style={{
        fontStyle: "normal",
        textTransform: "none",
        backgroundImage: "linear-gradient(0deg, #3172F2 0%, #00A6FF 100%)",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        color: "transparent",
      }}
    >
      {title}
    </div>
  );
};
